import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NewsStatus } from "../../models/news-status.enum";
import { News } from "../../models/news.model";

@Component({
    selector: "ntf-news-list-item",
    templateUrl: "news-list-item.component.html",
    styleUrls: ["news-list-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsListItemComponent {
    @Input()
    public news: News;

    public NewsStatus = NewsStatus;
}
